import { formatDayMonth } from '../../utils/subscriptionFormat';

// Mesma lista de customer-portal.php: com estes status quem não é dono abre o portal só para a forma de pagamento
export const PAYMENT_PENDING_STATUSES = ['past_due', 'unpaid', 'incomplete', 'inactive'];

const daysUntil = (value) => {
  if (!value) return null;
  const end = new Date(String(value).replace(' ', 'T'));
  if (isNaN(end.getTime())) return null;
  return Math.max(0, Math.ceil((end.getTime() - Date.now()) / 86400000));
};

const trialPillText = (days) => {
  if (days === null || days === undefined) return 'Em teste';
  if (days <= 1) return 'Em teste, termina amanhã';
  return `Em teste, ${days} dias restantes`;
};

/**
 * Decide qual situação o card principal mostra.
 * kind: active | paymentIssue | internalTrial | trialExpired | canceled | none
 */
export const getPlanHeroState = ({
  subscription,
  inTrial,
  trialDaysRemaining,
  trialExpired,
  pastDueInGrace,
  graceDeadline,
}) => {
  const status = subscription?.subscription_status?.toLowerCase() || '';

  if (status === 'canceled') {
    return { kind: 'canceled', status, pill: { tone: 'neutral', text: 'Encerrado' } };
  }

  const withoutPlan = !subscription || subscription.has_active_plan === false || status === 'inactive';
  if (withoutPlan) {
    // Já teve assinatura no Stripe: pagamento falhou e ficou inativa
    if (subscription?.stripe_subscription_id) {
      return {
        kind: 'paymentIssue',
        status,
        pill: { tone: 'error', text: status === 'inactive' ? 'Inativo' : 'Pagamento pendente' },
      };
    }
    if (inTrial) {
      return { kind: 'internalTrial', status, pill: { tone: 'info', text: trialPillText(trialDaysRemaining) } };
    }
    if (trialExpired) {
      return { kind: 'trialExpired', status, pill: { tone: 'neutral', text: 'Teste encerrado' } };
    }
    return { kind: 'none', status, pill: { tone: 'neutral', text: 'Sem plano' } };
  }

  const cancelDate = formatDayMonth(subscription.next_due_date);
  let pill;
  switch (status) {
    case 'active':
      pill = { tone: 'success', text: 'Ativo' };
      break;
    case 'trialing':
      pill = { tone: 'info', text: trialPillText(daysUntil(subscription.trial_ends_at)) };
      break;
    case 'canceling':
      pill = { tone: 'warning', text: cancelDate ? `Cancelamento agendado para ${cancelDate}` : 'Cancelamento agendado' };
      break;
    case 'past_due':
      pill = pastDueInGrace
        ? { tone: 'warning', text: graceDeadline ? `Pagamento pendente até ${graceDeadline}` : 'Pagamento pendente' }
        : { tone: 'error', text: 'Assinatura suspensa' };
      break;
    case 'pending':
      pill = { tone: 'warning', text: 'Pendente' };
      break;
    default:
      pill = { tone: 'neutral', text: status || 'Desconhecido' };
  }
  return { kind: 'active', status, pill };
};
